import React from "react";

// Elegant eye mark for Centro Oftalmológico Santa Lucía
export default function Logo({ size = 40, light = false, showText = true }) {
  const mark = light ? "#ffffff" : "#0b2545";
  const iris = light ? "#5aa9f0" : "#2e86de";
  return (
    <div className="flex items-center gap-3 select-none">
      <div
        className="grid place-items-center rounded-xl"
        style={{
          width: size,
          height: size,
          background: light
            ? "rgba(255,255,255,0.12)"
            : "linear-gradient(150deg,#e8f2fd,#ffffff)",
          border: light ? "1px solid rgba(255,255,255,0.25)" : "1px solid #dbe7f5",
        }}
      >
        <svg width={size * 0.62} height={size * 0.62} viewBox="0 0 48 48" fill="none">
          <path
            d="M4 24C4 24 12 12 24 12C36 12 44 24 44 24C44 24 36 36 24 36C12 36 4 24 4 24Z"
            stroke={mark}
            strokeWidth="2.6"
            strokeLinejoin="round"
          />
          <circle cx="24" cy="24" r="7.5" fill={iris} />
          <circle cx="24" cy="24" r="3" fill={light ? "#0b2545" : "#071a33"} />
          <circle cx="21.5" cy="21.5" r="1.4" fill="#ffffff" />
        </svg>
      </div>
      {showText && (
        <div className="leading-tight">
          <div
            className="text-[10px] font-semibold tracking-[0.22em] uppercase"
            style={{ color: light ? "rgba(255,255,255,0.7)" : "#6b8199" }}
          >
            Centro Oftalmológico
          </div>
          <div
            className="font-display font-extrabold text-lg -mt-0.5"
            style={{ color: light ? "#ffffff" : "#0b2545" }}
          >
            Santa Lucía
          </div>
        </div>
      )}
    </div>
  );
}
